// import React from "react";
// import { FaUserTie, FaCarSide, FaHandshake, FaCrown } from "react-icons/fa";

// const cards = [
//   {
//     title: "Executive Travel Excellence",
//     desc: "Delivering a new benchmark in business mobility — Pune Corporate Cars India Private Limited ensures precision, punctuality, and comfort for every executive journey. Experience travel that inspires confidence.",
//     icon: <FaUserTie />,
//     highlight: "24×7 Chauffeur Service",
//   },
//   {
//     title: "Luxury Fleet Designed for Professionals",
//     desc: "From luxury sedans to business-class SUVs, our fleet blends elegance with performance. Each vehicle is meticulously maintained to ensure comfort, safety, and sophistication.",
//     icon: <FaCarSide />,
//     highlight: "Premium Sedans & SUVs",
//   },
//   {
//     title: "Reliable Partner for Corporate Transfers",
//     desc: "Pune Corporate Cars India Private Limited is the trusted choice for intercity business travel. Our disciplined chauffeurs and real-time coordination guarantee punctuality and peace of mind.",
//     icon: <FaHandshake />,
//     highlight: "100+ Corporate Clients",
//   },
// //   {
// //     title: "Premium Comfort. Every Mile.",
// //     desc: "Whether it’s airport pickup or multi-city transfers, we redefine comfort and class. Every ride is managed with precision, professionalism, and complete client focus.",
// //     icon: <FaCrown />,
// //     highlight: "On-Time Guarantee",
// //   },
// ];

// const BrandSection = () => {
//   return (
//     <section className="brand-section">
//       <div className="container">
//         <div className="section-header">
//           <span className="badge">Pune Corporate Cars India Private Limited</span>
//           <h2>Corporate Travel. Reinvented with Perfection.</h2>
//           <p>
//             We craft seamless travel experiences for professionals who value
//             time, comfort, and sophistication — setting new standards in
//             executive mobility.
//           </p>
//         </div>

//         <div className="card-grid">
//           {cards.map((card, index) => (
//             <div className="brand-card" key={index}>
//               <div className="icon-wrap border">{card.icon}</div>
//               <h4>{card.title}</h4>
//               <p>{card.desc}</p>
//               <div className="card-footer">{card.highlight}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default BrandSection;










// import React from "react";
// import { FaUserTie, FaCarSide, FaHandshake, FaCheckCircle } from "react-icons/fa";

// const cards = [
//   {
//     title: "Executive Travel Excellence",
//     desc: "Delivering a new benchmark in business mobility — Pune Corporate Cars India Private Limited ensures precision, punctuality, and comfort for every executive journey. Experience travel that inspires confidence.",
//     icon: <FaUserTie />,
//     highlight: "24×7 Chauffeur Service",
//   },
//   {
//     title: "Luxury Fleet Designed for Professionals",
//     desc: "From luxury sedans to business-class SUVs, our fleet blends elegance with performance. Each vehicle is meticulously maintained to ensure comfort, safety, and sophistication.",
//     icon: <FaCarSide />,
//     highlight: "Premium Sedans & SUVs",
//   },
//   {
//     title: "Reliable Partner for Corporate Transfers",
//     desc: "Pune Corporate Cars India Private Limited is the trusted choice for intercity business travel. Our disciplined chauffeurs and real-time coordination guarantee punctuality and peace of mind.",
//     icon: <FaHandshake />,
//     highlight: "100+ Corporate Clients",
//   },
// ];

// // ================= TOPIC BOXES =================
// const topics = [
//   "Pan-India | Efficient | Trusted | Dependable",
//   "Corporate | Reliable | Premium | Assured",
//   "Timely | Trusted | Secure | Comfortable",
//   "Professional | Punctual | Safe | Reliable",
//   "Smooth | Seamless | Premium | Comfortable",
//   "Clean | Comfortable | Secure | Reliable",
//   "Efficient | Assured | Reliable | Swift",
//   "Trusted | Polite | Professional | Secure",
//   "Corporate | Safe | Swift | Dependable",
//   "Premium | Reliable | Smooth | Assured",
// ];

// const BrandSection = () => {
//   return (
//     <section className="brand-section">
//       <div className="container">

//         {/* HEADER */}
//         <div className="section-header">
//           <span className="badge">Pune Corporate Cars India Private Limited</span>
//           <h2>Corporate Travel. Reinvented with Perfection.</h2>
//           <p>
//             We craft seamless travel experiences for professionals who value
//             time, comfort, and sophistication — setting new standards in
//             executive mobility.
//           </p>
//         </div>

//         {/* === NEW SLIDING TOPIC BOXES === */}
//         <div className="topics-slider">
//           <div className="topics-track">
//             {topics.concat(topics).map((item, index) => (
//               <div className="topic-box" key={index}>
//                 <div className="topic-icon">
//                   <FaCheckCircle />
//                 </div>
//                 <p>{item}</p>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* ORIGINAL CARD GRID */}
//         <div className="card-grid">
//           {cards.map((card, index) => (
//             <div className="brand-card" key={index}>
//               <div className="icon-wrap border">{card.icon}</div>
//               <h4>{card.title}</h4>
//               <p>{card.desc}</p>
//               <div className="card-footer">{card.highlight}</div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default BrandSection;
import React from "react";
import { FaUserTie, FaCarSide, FaHandshake, FaCheckCircle } from "react-icons/fa";

// ----------- Existing 3 Cards -------------
const cards = [
  {
    title: "Executive Travel Excellence",
    desc: "Delivering a new benchmark in business mobility — Pune Corporate Cars India Private Limited ensures precision, punctuality, and comfort for every executive journey. Experience travel that inspires confidence.",
    icon: <FaUserTie />,
    highlight: "24×7 Chauffeur Service",
  },
  {
    title: "Luxury Fleet Designed for Professionals",
    desc: "From luxury sedans to business-class SUVs, our fleet blends elegance with performance. Each vehicle is meticulously maintained to ensure comfort, safety, and sophistication.",
    icon: <FaCarSide />,
    highlight: "Premium Sedans & SUVs",
  },
  {
    title: "Reliable Partner for Corporate Transfers",
    desc: "Pune Corporate Cars India Private Limited is the trusted choice for intercity business travel. Our disciplined chauffeurs and real-time coordination guarantee punctuality and peace of mind.",
    icon: <FaHandshake />,
    highlight: "100+ Corporate Clients",
  },
];

// ----------- NEW TOPIC CARDS (same format as above) -------------
const topicCards = [
  {
    title: "Pan-India Presence",
    desc: "Pune Corporate Cars India Private Limited provides seamless corporate travel support across all major business cities in India. Whether it's intercity movement, airport transfers, or multi-city business tours, our extensive nationwide network ensures smooth coordination and consistently reliable professional service.",
    icon: <FaCheckCircle />,
    highlight: "Nationwide Travel",
  },
  {
    title: "Efficient Operations",
    desc: "We optimize every ride with smart route planning, quick response times, and disciplined chauffeur coordination. Pune Corporate Cars India Private Limited ensures business travelers experience fast pickups, reduced delays, and an efficient travel workflow tailored for busy corporate schedules.",
    icon: <FaCheckCircle />,
    highlight: "Fast & Reliable",
  },
  {
    title: "Premium Comfort",
    desc: "Our executive fleet delivers unmatched comfort with business-class seating, plush interiors, and superior ride quality. Pune Corporate Cars India Private Limited guarantees a premium travel experience designed to help professionals relax, prepare, or work during their journey.",
    icon: <FaCheckCircle />,
    highlight: "Premium Experience",
  },
  {
    title: "Assured Quality",
    desc: "Every ride is backed by strict service standards, top-notch vehicle cleanliness, and well-maintained corporate-class cars. Pune Corporate Cars India Private Limited maintains consistent quality to ensure every client enjoys a flawless and dependable travel experience.",
    icon: <FaCheckCircle />,
    highlight: "Guaranteed Quality",
  },
  {
    title: "Timely Pickup",
    desc: "Punctuality is our strongest promise. Pune Corporate Cars India Private Limited ensures precise pickup timings for business meetings, corporate events, conferences, and airport runs — helping clients maintain professional commitments without delays.",
    icon: <FaCheckCircle />,
    highlight: "On-Time Promise",
  },
  {
    title: "Complete Security",
    desc: "We prioritize passenger safety with trained chauffeurs, GPS-enabled vehicles, verified drivers, and real-time ride monitoring. Pune Corporate Cars India Private Limited ensures total security for corporate employees, executives, and VIP guests at all times.",
    icon: <FaCheckCircle />,
    highlight: "Secure Travel",
  },
  {
    title: "Professional Chauffeurs",
    desc: "All chauffeurs undergo corporate etiquette training, safety workshops, and behavior assessments. Pune Corporate Cars India Private Limited ensures every driver maintains professionalism, discretion, and courtesy suitable for high-profile business travelers.",
    icon: <FaCheckCircle />,
    highlight: "Corporate-Trained",
  },
  {
    title: "Comfortable Trips",
    desc: "With spacious interiors, smooth suspension, and noise-free cabins, our fleet guarantees relaxing journeys even during long-distance corporate travel. Pune Corporate Cars India Private Limited focuses on providing unparalleled comfort for executives on the move.",
    icon: <FaCheckCircle />,
    highlight: "Smooth Ride",
  },
  {
    title: "Highly Reliable",
    desc: "Trusted by top corporates, startups, and enterprise clients, Pune Corporate Cars India Private Limited operates 24×7 to ensure dependable travel support. Our reliability makes us the preferred choice for daily office commute, intercity transfers, and business mobility needs.",
    icon: <FaCheckCircle />,
    highlight: "Reliable Service",
  },
  {
    title: "Seamless Coordination",
    desc: "From booking to drop-off, everything is handled through streamlined coordination, advanced fleet management, and disciplined execution. Pune Corporate Cars India Private Limited provides smooth, well-organized business travel with zero hassles.",
    icon: <FaCheckCircle />,
    highlight: "Hassle-Free",
  },
];


const BrandSection = () => {
  return (

<>




    <section className="brand-section">
      <div className="containerr">

        {/* HEADER */}
        <div className="section-headerr text-center">
          <span className="badge text-center">Pune Corporate Cars India Private Limited</span>
          {/* <h2>Corporate Travel. Reinvented with Perfection.</h2> */}
          <h2>Seamless Pan-India corporate mobility for professionals who value excellence.</h2>
         <section className="company-details-section covered-section">

  <div className="container">

    {/* ===== INTRO ===== */}
    <p className="company-main-text">
      Pune Corporate Cars India Pvt Ltd is a professional corporate car rental
      and ground transportation service provider based in Pune, Maharashtra,
      India. The company is well known for delivering premium chauffeured travel
      solutions for businesses, institutions, and individual clients across
      100+ major cities. It operates 24/7 with a strong reputation for quality
      and reliability, reflected in high customer ratings.
    </p>

    {/* ===== KEY POINTS ===== */}
    <ul className="company-points">
      <li>
        <strong>Business Type:</strong> Car rental services specializing in
        corporate and premium mobility
      </li>

      <li>
        <strong>Founded:</strong> Incorporated on 18 June 2013 under MCA
        (Registrar of Companies, Pune) with CIN
        <strong> U63030PN2022PTC212230</strong>
      </li>

      <li>
        <strong>Certifications:</strong> ISO 9001:2015 and ISO 14001:2015
        certified organization, committed to international standards of
        quality management and environmental responsibility.
      </li>

      <li>
        <strong>Rating:</strong> ⭐ 5.0 based on ~40 user reviews for service
        quality and vehicle condition
      </li>
    </ul>

    {/* ===== DIRECTORS ===== */}
    <div className="company-directors-box">
      <h3>👔 Key Directors</h3>

      <ul>
        <li>
          <strong>Sanjay Dashrath Nalawade</strong> – Director (Incorporation
          Director)
        </li>
        <li>
          <strong>Prashant Dajiba Nalawade</strong> – Director (Co-promoter)
        </li>
      </ul>

      <p className="director-description">
        These directors are responsible for strategic decisions, corporate
        partnerships, and service standards. As directors, they also ensure
        statutory compliance and operational oversight of the company’s
        growth.
      </p>
    </div>

  </div>
</section>




        </div>

        {/* --------- SLIDING TOPIC CARDS ---------- */}
        <div className="slide-wrapper">
          <div className="slide-track">
            {topicCards.concat(topicCards).map((item, i) => (
              <div className="brand-card slide-card" key={i}>
                <div className="icon-wrap border">{item.icon}</div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
                <div className="card-footer">{item.highlight}</div>
              </div>
            ))}
          </div>
        </div>

        {/* --------- ORIGINAL 3 CARDS ---------- */}
        {/* <div className="card-grid">
          {cards.map((card, index) => (
            <div className="brand-card" key={index}>
              <div className="icon-wrap border">{card.icon}</div>
              <h4>{card.title}</h4>
              <p>{card.desc}</p>
              <div className="card-footer">{card.highlight}</div>
            </div>
          ))}
        </div> */}

      </div>
    </section>

</>
  );
};

export default BrandSection;
